import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import { useApplicationFlags } from 'hooks/useApplicationFlags';
import { useTranslationSuffix } from 'hooks/useTranslationSuffix';
import Expenses from './ExpensesAU';
import UpgradeExpenses from './UpgradeExpensesAU';

const propTypes = {
  incomeFrequencies: PropTypes.array.isRequired,
  totalLivingExpenses: PropTypes.string,
  residenceTypes: PropTypes.array.isRequired,
  otherExpensesFieldsDescriptor: PropTypes.array.isRequired,
  residentialStatus: PropTypes.string,
  nonEssentialExpenses: PropTypes.string,
  willForgoNonEssentials: PropTypes.bool,
};

const ExpensesAU = (props) => {
  const { isOcmOrUpgrade } = useApplicationFlags();
  const title = useTranslationSuffix('upgrade', 'expenses.title');

  return (
    <div className="loan-form__step">
      <h1 className="loan-form__step-title">
        <FormattedMessage id={title} />
      </h1>
      {isOcmOrUpgrade
        ? (
          <UpgradeExpenses
            incomeFrequencies={props.incomeFrequencies}
            otherExpensesFieldsDescriptor={props.otherExpensesFieldsDescriptor}
            totalLivingExpenses={props.totalLivingExpenses}
          />
        )
        : (
          <Expenses
            totalLivingExpenses={props.totalLivingExpenses}
            incomeFrequencies={props.incomeFrequencies}
            residentialStatus={props.residentialStatus}
            residenceTypes={props.residenceTypes}
            nonEssentialExpenses={props.nonEssentialExpenses}
            willForgoNonEssentials={props.willForgoNonEssentials}
          />
        )}
    </div>
  );
};

ExpensesAU.propTypes = propTypes;

const selector = formValueSelector('loan');

export default connect(
  (state) => ({
    residentialStatus: selector(state, 'residentialStatus'),
    totalLivingExpenses: selector(state, 'totalLivingExpenses'),
    willForgoNonEssentials: selector(state, 'willForgoNonEssentials'),
  })
)(ExpensesAU);
